import { render, staticRenderFns } from "./ActionDiagnosticoImposible.vue?vue&type=template&id=0fcd9b39&lang=pug"
import script from "./ActionDiagnosticoImposible.vue?vue&type=script&lang=js"
export * from "./ActionDiagnosticoImposible.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports